module.exports = __webpack_public_path__ + "04fe54c48415ed11df31bc0873020c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_3_2023_chart.png
// module id = 1739
// module chunks = 0